type IPermission = {
  key: string;
  description: string;
};

export class Permission {
  public readonly key: string;
  public readonly description: string;

  constructor({ key, description }: IPermission) {
    this.key = key;
    this.description = description;
  }

  toString(): string {
    return this.key;
  }
}

export type PermissionConfiguration<T extends string = string> = Record<T, Permission>;

export const definePermissions = <T extends string = string>(
  permissions: PermissionConfiguration<T>,
): PermissionConfiguration<T> => {
  return permissions;
};
